import React from 'react';
import styled from 'styled-components';
import { Gauge } from 'styled_components/Common/Gauge';

const ColoGaugeStyle = styled.div`
	width: 100%;
	height: 100%;
	//background-color: ${props => props.theme.white};
	display: flex;
	justify-content: center;
	align-items: center;
	.gauge-container {
		display: flex;
		justify-content: center;
		align-items: flex-end;
		width: 600px;
		height: 200px;
		.second-gauge {
			width: 200px;
			height: 200px;
		}
		.first-gauge,
		.third-gauge {
			width: 100px;
			height: 100px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.gauge-container {
			width: 800px;
			height: 300px;
			.second-gauge {
				width: 300px;
				height: 300px;
			}
			.first-gauge,
			.third-gauge {
				width: 150px;
				height: 150px;
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.high}) {
		.gauge-container {
			width: 800px;
			height: 300px;
			.second-gauge {
				width: 300px;
				height: 300px;
			}
			.first-gauge,
			.third-gauge {
				width: 150px;
				height: 150px;
			}
		}
	}
`;

export const ColoGauge = ({ id, cypressId }) => {
	return (
		<ColoGaugeStyle id={id} data-cy={cypressId} className='current-power'>
			<div className='gauge-container'>
				<div className='first-gauge'>
					<Gauge pathColor1='red' pathColor2='#A2A9AD' status='status' size='small' />
				</div>
				<div className='second-gauge'>
					<Gauge pathColor1='#00AD5C' pathColor2='#A2A9AD' status='Balanced' size='large' />
				</div>
				<div className='third-gauge'>
					<Gauge pathColor1='red' pathColor2='#A2A9AD' status='status' size='small' />
				</div>
			</div>
		</ColoGaugeStyle>
	);
};
